/**
 * Ouvre le selecteur natif d'un champ date ou heure.
 *
 * Les navigateurs ne l'ouvrent d'eux-memes que sur une icone de quelques
 * pixels ; `showPicker` permet de rendre toute la boite cliquable. Il
 * n'existe pas partout — Safari iOS ouvre deja son rouleau au premier
 * contact — d'ou le repli silencieux sur le focus.
 */
export function openPicker(input: HTMLInputElement | null) {
  if (!input) return;
  try {
    input.showPicker();
  } catch {
    input.focus();
  }
}
